import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Scissors, Eye } from 'lucide-react';
const services = [{
  id: 'unas',
  title: 'UÑAS',
  icon: Sparkles,
  description: 'Semipermanente, acrílico, gel y nail art. Diseños únicos para cada estilo.'
}, {
  id: 'cejas',
  title: 'CEJAS',
  icon: Scissors,
  description: 'Diseño, depilación y laminado. Enmarcamos tu mirada a la perfección.'
}, {
  id: 'pestanas',
  title: 'PESTAÑAS',
  icon: Eye,
  description: 'Extensiones y lifting. Realzamos tu mirada naturalmente.'
}];
export const Services = () => {
  return <section id="servicios" className="py-20 md:py-32 bg-white" data-id="element-184">
      <div className="max-w-6xl mx-auto px-6" data-id="element-185">
        <div className="text-center mb-16" data-id="element-186">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-heading font-bold text-brand-dark mb-4" data-id="element-187">
            Nuestros Servicios
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-brand-magenta font-medium" data-id="element-188">
            Cada detalle importa
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-189">
          {services.map((service, index) => <motion.div key={service.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1 + 0.2
        }} className="group bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 relative overflow-hidden" data-id="element-190">
              <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-brand opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-191"></div>

              <div className="w-16 h-16 rounded-full bg-gradient-brand p-[2px] mb-6 inline-block" data-id="element-192">
                <div className="w-full h-full bg-white rounded-full flex items-center justify-center" data-id="element-193">
                  <service.icon className="text-brand-magenta" size={28} data-id="element-194" />
                </div>
              </div>

              <h3 className="text-xl font-bold font-heading mb-3 text-brand-dark tracking-wide" data-id="element-195">
                {service.title}
              </h3>
              <p className="text-brand-dark/70 leading-relaxed" data-id="element-196">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};